import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/IR_LEDs/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import IRTable from 'components/Web_User_Interface/1440p_Series/Features/IR_LEDs/irTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü // Nachtsicht LEDs",
  "path": "/Web_User_Interface/1440p_Serie/Features/IR_Nachtsicht/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die IR LEDs in Ihrer Kamera werden automatisch durch den Lichtsensor ein- und ausgeschaltet. Wenn Sie Ihre Kamera hinter einem hoch reflektierten Fenster zum Beispiel als Wetterkamera verwenden möchten und die IR LEDs nicht benötigen, deaktivieren Sie die LEDs einfach hier. Beachten Sie, dass der automatische IR Cutfilter sich automatisch permament vor die Linse bewegt. Das heißt Sie können kein externes IR Licht verwenden, wenn die internen IR Lampen ausgeschaltet sind.",
  "image": "./WebUI_1440p_SearchThumb_Features_Nightvision.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_Nightvision.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Features Menü // Nachtsicht LEDs' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die IR LEDs in Ihrer Kamera werden automatisch durch den Lichtsensor ein- und ausgeschaltet. Wenn Sie Ihre Kamera hinter einem hoch reflektierten Fenster zum Beispiel als Wetterkamera verwenden möchten und die IR LEDs nicht benötigen, deaktivieren Sie die LEDs einfach hier. Beachten Sie, dass der automatische IR Cutfilter sich automatisch permament vor die Linse bewegt. Das heißt Sie können kein externes IR Licht verwenden, wenn die internen IR Lampen ausgeschaltet sind.' image='/images/Search/WebUI_1440p_SearchThumb_Features_Nightvision.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_Nightvision.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/IR_LEDs/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/IR_LEDs/' crumbLabel="Infrared Nightvision" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/60b5c4e62b0fbc8fc25a94574726667d/2e367/1440p_Settings_Features_Nightvision.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.30434782608696%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAA7rAAAO6wFxzYGVAAACXklEQVQoz22TS08TUQBG+yPUBWiagm2gLQQCRmw7bSlU6GPa3nncmbYMmKBEIQFRCigJssAXbo0J7nQnuvWxUBeuXLhx7Y855k6lFOLi5CazODnzzZ3A8PAw8XiceHyIgXCITH2L6t4nCpvvmN446pBvKd4z3frAzOYR7uMvpJwW6eRVYvEhenp6CAaDBKLRKIpYLEb4ch+5ikdj/QX11SfU1552sFf2sW7vYt7cxry1TWPtGQW5RGLiGlfGJxgZGWN0dJyAEh0TjkTIaAmkKCOFjlEpIMozCL2AKE4hbtzF3T3C3DhEiCql/DS5TJFCwSCbmSaVzJ4URqMxwuEw2ewkbr1BvdHEtiWmZfsIUcPwlpGrB3jrzzGcOqIoMPMeRmmeqckcmpYhMDg46NcpaVuYxXEcpJQdLNNECIEpKljVInatjDBqyJpkx5mn5dlUqzm0VLotPK7sFipc1/WFvsw0sWwby5bMeR6WZVMuzfBgWbK/JTCqGqlEl1BVRiKRU0Lbtn2RYRhtoWV10HWd5TtL/Pj+mbcH9ynlkyeF6tr8r1DVKZkqPD79WsumUCiyt7vDn18/+XX4igU9TzKZPF14dkNVosoUqlZK9dzGcRsUyzoP763z++tHvr15zaMFnUxG6/7KJ4Vqu3q9QbPZ9Gm/voWo1ZD/ZhCGgV4qUbo+xWx+ksRYjFh04Mw97BIqHOl0Npyb82h4C7jePLZh4kqJpmmcO3+Bnt5eLl4Knv5TjgvT6bS/U6VS8YfX1VkqIha3qbUOWWyu8DI/y26xQjKV8iX9/f30hUKEQiH+AgG4xcXft5rJAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/60b5c4e62b0fbc8fc25a94574726667d/e4706/1440p_Settings_Features_Nightvision.avif 230w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/d1af7/1440p_Settings_Features_Nightvision.avif 460w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/7f308/1440p_Settings_Features_Nightvision.avif 920w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/730d0/1440p_Settings_Features_Nightvision.avif 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/60b5c4e62b0fbc8fc25a94574726667d/a0b58/1440p_Settings_Features_Nightvision.webp 230w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/bc10c/1440p_Settings_Features_Nightvision.webp 460w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/966d8/1440p_Settings_Features_Nightvision.webp 920w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/fbb05/1440p_Settings_Features_Nightvision.webp 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/60b5c4e62b0fbc8fc25a94574726667d/81c8e/1440p_Settings_Features_Nightvision.png 230w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/08a84/1440p_Settings_Features_Nightvision.png 460w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/c0255/1440p_Settings_Features_Nightvision.png 920w", "/de/static/60b5c4e62b0fbc8fc25a94574726667d/2e367/1440p_Settings_Features_Nightvision.png 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/60b5c4e62b0fbc8fc25a94574726667d/c0255/1440p_Settings_Features_Nightvision.png",
              "alt": "Web User Interface - 1440p Series - Features IR LEDs",
              "title": "Web User Interface - 1440p Series - Features IR LEDs",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Die IR-LEDs Ihrer Kamera werden durch den internen Lichtsensor automatisch ein- und ausgeschaltet. Wenn Sie Ihre Kamera hinter einem stark reflektierenden Fenster verwenden möchten oder Ihre Kamera als Wetter-Webcam nutzen und das IR-Licht nicht benötigen, deaktivieren Sie die LEDs hier einfach.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <IRTable mdxType="IRTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "bitte-beachten-sie",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bitte-beachten-sie",
        "aria-label": "bitte beachten sie permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bitte beachten Sie`}</h3>
    <p>{`Wenn Sie die IR-LEDs in der Nacht deaktivieren, kann es zu Fehlalarmen durch die interne Bewegungserkennung kommen. In diesem Fall müssen Sie die Bewegungserkennung während der Nacht über den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Schedule/"
      }}>{`Alarmzeitplan`}</a>{`  deaktivieren.`}</p>
    <h3 {...{
      "id": "erweiterte-einstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#erweiterte-einstellungen",
        "aria-label": "erweiterte einstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Erweiterte Einstellungen`}</h3>
    <p>{`Kameras mit mehreren LED-Sets verfügen über zusätzliche Einstellungen. Das Modell IN-8401 2k+ WQHD verfügt beispielsweise über "unsichtbare" (940 nm) Nachtsicht-IR-LEDs und einen Satz 850-nm-IR-LEDs, die stärker sind, aber sichtbar sind, wenn sie aktiv sind, da sie einen leichten roten Schimmer ausstrahlen. Aus diesem Grund sollten Sie sie in verschiedenen Situationen getrennt verwenden:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/bebe8426851eb69e4d50addd293a888b/2e367/1440p_Settings_Features_Nightvision_8401.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.30434782608696%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAA7rAAAO6wFxzYGVAAACi0lEQVQoz2WTzU8TQRiH+SPUA2qaSkqEVoJRo7K00EKFpV33e6a7WxY1AQkiQWlBglE0fsUYTTTx24NejN7VmCgmnjxw8ewf85hZrAIefpnMvMkzz5t3pq2np4dcLkcud4D9mTSFYAlz9SP64juGG+//ptzcyHDzPSPNd9RufUaTTQraUbK5A7S3t5NKpWjr7u5GJZvNkulIM2TFjDfuE8zdIpq/QzR/O1nl7A38met406u4Z68kdV1M0XfsOEcOH6O39xAHDx6mTYFayWQ6GSxoRMLGt6pUxnRGdR1d1xkdGaFiWHiNpwRX3uI2njKmG5QKo+i6y+DAMP3a4DbDTIZiqUQY1fE9j3vnDV40qjxZMHjVrHBtLsS6+Y3w4U/c22vYZoQ7FOJUY4aKJfL5Adq6uroSmIImwGKRKIqQQrBwxmZlymJ50mJl0mR2wsGKpvFPzRLPNJB2jRUZ0xz3Mc0S+f7CBrBl2QKGQYAvBKYrMBxB1fLQDYeq6SBcC88x8V2bamWE5RnBjSUbx8zT37cJqCw7OzsTYKCAvk9NCqTwcRwb13E24npJTcqAczNTfF/7xJu7C1TK2j9D9Ww2G9brdaSUCCHwPA/LspJVgdSZqtm2w+rVy/xa/8H6s8dMGGU0TdtqqIClUok4jpO2gz9RAAVsRe2rhsHyxQv8/PKBr6+fc3XCYGAg/2/K/w1FygRWq9USiLpAtawMhZBYto1RGaN6YojRcpG+Q1my3fu3v8M/QwnDpD0FchwH27YJwoiwHlOrx8goIpI18vl+duzcRfvu3ezZm9r6U1qGhUIhgRiGsZGTJzEqOtaZS9iLLxk/vcSD8gkejZkMaxp7Uyk6OjrYl06TTqf5DczNyyPnRtalAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bebe8426851eb69e4d50addd293a888b/e4706/1440p_Settings_Features_Nightvision_8401.avif 230w", "/de/static/bebe8426851eb69e4d50addd293a888b/d1af7/1440p_Settings_Features_Nightvision_8401.avif 460w", "/de/static/bebe8426851eb69e4d50addd293a888b/7f308/1440p_Settings_Features_Nightvision_8401.avif 920w", "/de/static/bebe8426851eb69e4d50addd293a888b/730d0/1440p_Settings_Features_Nightvision_8401.avif 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/bebe8426851eb69e4d50addd293a888b/a0b58/1440p_Settings_Features_Nightvision_8401.webp 230w", "/de/static/bebe8426851eb69e4d50addd293a888b/bc10c/1440p_Settings_Features_Nightvision_8401.webp 460w", "/de/static/bebe8426851eb69e4d50addd293a888b/966d8/1440p_Settings_Features_Nightvision_8401.webp 920w", "/de/static/bebe8426851eb69e4d50addd293a888b/fbb05/1440p_Settings_Features_Nightvision_8401.webp 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bebe8426851eb69e4d50addd293a888b/81c8e/1440p_Settings_Features_Nightvision_8401.png 230w", "/de/static/bebe8426851eb69e4d50addd293a888b/08a84/1440p_Settings_Features_Nightvision_8401.png 460w", "/de/static/bebe8426851eb69e4d50addd293a888b/c0255/1440p_Settings_Features_Nightvision_8401.png 920w", "/de/static/bebe8426851eb69e4d50addd293a888b/2e367/1440p_Settings_Features_Nightvision_8401.png 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/bebe8426851eb69e4d50addd293a888b/c0255/1440p_Settings_Features_Nightvision_8401.png",
              "alt": "Web User Interface - 1440p Series - Features IR LEDs",
              "title": "Web User Interface - 1440p Series - Features IR LEDs",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      